// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimProviderLocationModel {
    static getAttributeTypeMap() {
        return ClaimProviderLocationModel.attributeTypeMap;
    }
}
ClaimProviderLocationModel.discriminator = undefined;
ClaimProviderLocationModel.additionalProperties = false;
ClaimProviderLocationModel.attributeTypeMap = [
    {
        "name": "providerLocationId",
        "baseName": "providerLocationId",
        "type": "number"
    },
    {
        "name": "locationPurposeTypeCode",
        "baseName": "locationPurposeTypeCode",
        "type": "string"
    },
    {
        "name": "locationPurposeTypeDescription",
        "baseName": "locationPurposeTypeDescription",
        "type": "string"
    },
    {
        "name": "providerId",
        "baseName": "providerId",
        "type": "number"
    },
    {
        "name": "locationPurposeTypeId",
        "baseName": "locationPurposeTypeId",
        "type": "number"
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
    {
        "name": "zipCode4",
        "baseName": "zipCode4",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "faxNumber",
        "baseName": "faxNumber",
        "type": "string"
    },
    {
        "name": "emailAddress",
        "baseName": "emailAddress",
        "type": "string"
    },
];
//# sourceMappingURL=claimProviderLocationModel.js.map